import { action, makeObservable, observable, runInAction } from 'mobx';
import BaseStore from '@context/global/mobx/BaseStore';
import NextCreativeApi from '@features/api/nextApiService/nextCreativeApi';
import { TUserCreativeType } from '@features/userPanel/typescript';
class UserPanelCreativeStore extends BaseStore {
  userCreative = observable(new Array<TUserCreativeType>());
  isLoading = false;
  constructor(customerId: string) {
    super();
    makeObservable(this, {
      userCreative: observable,
      isLoading: observable,
      loadCreative: action
    });
    this.loadCreative(customerId);
  }
  loadCreative = this.withProgress(async (customerID: string) => {
    this.isLoading = true;
    const responseUserCreativeProjects = await NextCreativeApi.getCreativeProjects(customerID);
    const {
      data
    } = await responseUserCreativeProjects;
    runInAction(() => {
      this.isLoading = false;
      if (data) {
        this.userCreative.replace(data);
      }
    });
    return this.userCreative;
  });
}
export default UserPanelCreativeStore;